import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ScreeningService } from '../screening-module/services/screening.service';
import { SupportIssueService } from '../issue-tracker/services/support-issue.service';
import { NotesService } from '../shared-components-module/notes-pane/Services/notes.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements AfterViewInit,OnInit{
 
  constructor(public auth : AuthService ,public screening : ScreeningService, public issues: SupportIssueService, public notes: NotesService, public httpService: HttpClient) {
  }

  ngAfterViewInit(): void {
    //RIQ-2098: if there are no support issues or the count is 0, try to re-fetch the issue count
    //resolves an edge case where the counts are displaying after a fresh login
    if(!this.issues.supportIssues || this.issues._issueCount === 0) {
      this.issues.fetchSupportIssueCounts();
    }

  }

  ngOnInit() {
   
  }
}
